import { flexRender, Row } from '@tanstack/react-table';
import { L } from 'harmony-language';
import React, { FC } from 'react';
import { Load } from '../../../../types';
import { AgisticsTooltip } from '../../../shared/agistics-tooltip';
import { useDraftsLoadsContext } from '../../drafts-loads-context';
import { useDraftLoadPreferences } from '../../hooks/useDraftLoadPreferences';
import { gridTemplateColumnsGenerator } from '../../utils/drafts-loads-utils';

interface LoadTableRowProps {
    row: Row<Load>;
}

export const LoadTableRow: FC<LoadTableRowProps> = (props) => {
    const { row } = props;
    const { getIsLoadStale } = useDraftsLoadsContext();
    const socketHasUpdatedData = getIsLoadStale(row.original);

    if (socketHasUpdatedData) {
        return (
            <AgisticsTooltip
                tooltip={L.socketRequestRefresh()}
                placement='top'
                removeFitContent={true}
            >
                <LoadTableRowInternal
                    row={row}
                    socketHasUpdatedData={socketHasUpdatedData}
                />
            </AgisticsTooltip>
        );
    } else {
        return (
            <LoadTableRowInternal
                row={row}
                socketHasUpdatedData={socketHasUpdatedData}
            />
        );
    }
}

interface LoadTableRowInternalProps {
    row: Row<Load>;
    socketHasUpdatedData: boolean;
}

const LoadTableRowInternal: FC<LoadTableRowInternalProps> = (props) => {
    const { row, socketHasUpdatedData } = props;
    const { isDrafts } = useDraftsLoadsContext();
    const { showLoadDate, showTractor, showTrailer, estimatedTotalTripMode } = useDraftLoadPreferences();

    return (
        <div
            className='lt-row'
            style={{
                gridTemplateColumns: gridTemplateColumnsGenerator(isDrafts, showLoadDate, estimatedTotalTripMode, showTractor, showTrailer),
                backgroundColor: socketHasUpdatedData ? '#d32f2f80' : undefined,
            }}
        >
            {row.getVisibleCells().map(cell => (
                <div
                    key={cell.id}
                    className='lt-cell lt-cell-sub'
                >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
            ))}
        </div>
    );
}
